import React, {useEffect, useState} from 'react';
// import { PlusOutlined } from '@ant-design/icons';
import {
    Form,
    Input,
    Button,
    Checkbox,
    Row, notification,
} from 'antd';
import { SpinnerDotted } from 'spinners-react';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";
const { TextArea } = Input;


const AboutUs = () => {
    const [form] = Form.useForm();
    const [componentDisabled, setComponentDisabled] = useState(true);
    const [setting, setSetting] = useState(null);


    useEffect(  () => {
        Axios.get(`${Api}get-about`
        )
            .then((data) => {
                if(data.statusCode === 200 || data.statusCode ===201){
                    setSetting(data.data.data);


                }
            })
            .catch((error) => {
            });

    }, []);


    const onCancel = () => {
        setComponentDisabled(true);
        form.resetFields();
    }

    const submit =  (e) => {
        form.validateFields()
            .then(async (values) => {
                const data = {
                    adress: values.adress,
                    phone_1: values.phone_1,
                    phone_2: values.phone_2,
                    phone_3: values.phone_3,
                    phone_4: values.phone_4,
                    title: values.title,
                    website: values.website,
                    descCall: values.descCall,
                    Slogan: values.Slogan

                }

                await Axios.put(`${Api}update-about/${setting.id}`, data).then(async (data) => {
                    if (data.statusCode === 200 || data.statusCode === 201) {
                        await notification.open({
                            message: "موفقیت",
                            description: "درخواست با موفقیت انجام شد!",
                            style: {
                                background: "#43a047",
                                color: "white",
                                fontFamily: "IRANSansMobileFaNum",
                                borderRadius: "5px",
                            }
                        })

                    }
                    else {
                        notification.open({
                            message: "اخطار",
                            description: data.message,
                            style: {
                                background: "#cc3838",
                                color: "white",
                                fontFamily: "IRANSansMobileFaNum",
                                borderRadius: "5px",
                            }
                        })
                    }

                })
                    .catch((error) => {
                    });

                await Axios.get(`${Api}get-about`
                )
                    .then((data) => {
                        if(data.statusCode === 200 || data.statusCode ===201){
                            setSetting(data.data.data);
                        }
                    })
                    .catch((error) => {
                    });

                await setComponentDisabled(true);



            })
            .catch((info) => {
            });
    }

    return (
        setting!=null?
            <>
                <Row style={{ marginBottom: "20px"}}>
                    <label style={{fontSize: "20px"}}>
                        ویرایش اطلاعات&nbsp;
                    </label>
                    <Checkbox style={{
                        fontSize: "20px"
                    }}
                              checked={!componentDisabled}
                              onChange={(e) => {
                                  e.target.checked === true ? setComponentDisabled(false): setComponentDisabled(true)

                              }}
                              name="check"
                    >

                    </Checkbox >
                </Row>

                <Form

                    initialValues={{
                        "title": setting.title,
                        "Slogan": setting.Slogan,
                        "phone_1": setting.phone1,
                        "phone_2": setting.phone2,
                        "phone_3": setting.phone3,
                        "phone_4": setting.phone4,
                        "descCall": setting.descCall,
                        "adress": setting.adress,
                        "website": setting.website,
                        modifier: 'public',
                    }}

                    form={form}
                    labelCol={{
                        span: 4,
                    }}
                    wrapperCol={{
                        span: 12,
                    }}
                    layout="horizontal"
                    // onValuesChange={onFormLayoutChange}
                    disabled={componentDisabled}
                >

                    <Form.Item label={<p style={{fontSize:"20px"}}>عنوان</p>} name="title"

                    >

                        <Input  style={{borderRadius: "6px", fontSize:"16px", height: "35px"}} />
                    </Form.Item>

                    <Form.Item label={<p style={{fontSize:"20px"}}>شعار</p>} name="Slogan">
                        <TextArea rows={2} style={{borderRadius: "6px", fontSize:"16px"}} />
                    </Form.Item>

                    <Form.Item label={<p style={{fontSize:"20px"}}>تلفن 1</p>} name="phone_1"

                    >

                        <Input  style={{borderRadius: "6px", fontSize:"16px", height: "35px"}} />
                    </Form.Item>

                    <Form.Item label={<p style={{fontSize:"20px"}}>تلفن 2</p>} name="phone_2"

                    >

                        <Input  style={{borderRadius: "6px", fontSize:"16px", height: "35px"}} />
                    </Form.Item>

                    <Form.Item label={<p style={{fontSize:"20px"}}>تلفن 3</p>} name="phone_3"

                    >

                        <Input  style={{borderRadius: "6px", fontSize:"16px", height: "35px"}} />
                    </Form.Item>

                    <Form.Item label={<p style={{fontSize:"20px"}}>تلفن 4</p>} name="phone_4"

                    >

                        <Input  style={{borderRadius: "6px", fontSize:"16px", height: "35px"}} />
                    </Form.Item>




                    <Form.Item label={<p style={{fontSize:"20px"}}>آدرس</p>} name="adress">
                        <TextArea rows={3} />
                    </Form.Item>

                    <Form.Item label={<p style={{fontSize:"20px"}}>آدرس وبسایت</p>} name="website"

                    >

                        <Input  style={{borderRadius: "6px", fontSize:"16px", height: "35px", textAlign:"center"}} />
                    </Form.Item>

                    <Form.Item  label={<p style={{fontSize:"20px"}}>توضیحات <br/>تماس</p>} name="descCall">
                        <TextArea rows={3} />
                    </Form.Item>


                    <Form.Item  colon={false} label={"     "} labelAlign="right" style={{marginBottom: "20px"}}>
                        <Button onClick={onCancel} style={{borderRadius:"8px"}} type="ghost" size="middle">انصراف</Button>&nbsp;&nbsp;&nbsp;
                        <Button onClick={submit} style={{borderRadius:"8px"}} type="primary" size="middle">ویرایش</Button>

                    </Form.Item>
                </Form>

            </>
            :<Row style={{ width: '100', justifyContent: 'center' }}>
                <SpinnerDotted size={89} thickness={180} speed={92} color="rgba(0, 0, 0, 0.85)" style={{ marginTop: '100px' }} />
            </Row>

    );
};
export default AboutUs;